module.exports = __webpack_public_path__ + "img/男-鼻咽癌h.3b1f67a6.png";